// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as IconCmp$PorterinFeature from "../IconCmp.mjs";
import * as FareEstimateVmV1$PorterinFeature from "../../../view-model/FareEstimateVmV1.mjs";
import * as AutoCompleteAddressCmp$PorterinFeature from "./AutoCompleteAddressCmp.mjs";
import * as AutoCompleteCardCmpModuleScss from "../../styles/AutoCompleteCardCmp.module.scss";

var styles = AutoCompleteCardCmpModuleScss;

function AutoCompleteCardCmp(Props) {
  var place_info = Props.place_info;
  var on_address_select = Props.on_address_select;
  return React.createElement("div", {
              key: place_info.place_id,
              className: styles.card,
              onClick: (function (param) {
                  Curry._1(on_address_select, place_info);
                })
            }, React.createElement(IconCmp$PorterinFeature.make, {
                  image: FareEstimateVmV1$PorterinFeature.location_pin
                }), React.createElement(AutoCompleteAddressCmp$PorterinFeature.make, {
                  text: place_info.structured_formatting.main_text,
                  sub_text: place_info.structured_formatting.secondary_text
                }));
}

var make = AutoCompleteCardCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
